import React, { useMemo } from 'react';
import { Control } from 'react-hook-form';

import { PaymentInfoForm } from '@/modules/partner/model/form';
import { TPartnerType } from '@/modules/partner/model/partnerType';
import { CountryCode, TCountryCodes } from '@/shared/models/country-code';
import { Section } from '@/shared/view/Section';

import { FrPaymentInfo } from './LocalizedForm/fr';
import { GbPaymentInfo } from './LocalizedForm/gb';
import { RuPaymentInfo } from './LocalizedForm/ru';
import { UaePaymentInfo } from './LocalizedForm/uae';
import { UsPaymentInfo } from './LocalizedForm/us';

type Props = {
  control: Control<PaymentInfoForm>;
  partnerType?: TPartnerType;
  countryCode: TCountryCodes;
};

const PaymentsView: React.FC<Props> = ({ control, partnerType, countryCode }) => {
  const form = useMemo(() => {
    switch (countryCode) {
      case CountryCode.Russia: {
        return <RuPaymentInfo partnerType={partnerType} control={control} />;
      }
      case CountryCode.France: {
        return <FrPaymentInfo control={control} />;
      }
      case CountryCode.ArabEmirates: {
        return <UaePaymentInfo control={control} />;
      }
      case CountryCode.UnitedStates: {
        return <UsPaymentInfo control={control} />;
      }
      default:
        return <GbPaymentInfo control={control} />;
    }
  }, [countryCode, partnerType, control]);

  return <Section>{form}</Section>;
};

export { PaymentsView };
